export { default }from './FastPayment';
